import api from 'services/api';

const route = '/order'

export const getListOrders = (params) => {
  return api().get(route, { params })
}

export const create = (params) => {
  return api().post(route, params)
}

export const update = (id, params) => {
  return api().put(route + `/${id}`, params)
}

export const read = (id, params) => {
  return api().get(route + `/${id}`, params)
}

export const deleteItem = (params) => {
  return api().delete(route + `/delete-orders`, { params })
}

export const exportPDF = (id, params = {}) => {
  return api().get(route + `/export-pdf/${id}`, { params });
}

// tạo mã hoá đơn cho đơn hàng

export const createOrderNo = (params = {}) => {
  return api().get(route + `/code`, { params });
}
// lấy danh sách kho theo trung tâm
export const getStocksOpts = (params = {}) => {
  return api().get(`/stocks/get-options`, { params });
}

// lấy tất cả danh sách sản phẩm
export const getAllProductList = ( params = {}) => {
  return api().get(`/sl-prices/prices-list`, { params })
}

// lấy danh sách sản phẩm 
export const getProductList = (id, params = {}) => {
  return api().get(route + `/stocks/${id}/products`, { params });
}

// lấy danh sách nhân viên nhận hoa hồng
export const getUserCommissionOpts = (params = {}) => {
  return api().get(route + `/option-user`, { params });
}

// lấy danh sách ngân hàng
export const getBankOpts = (params = {}) => {
  return api().get(route + `/bank-account/get-options`, { params });
}

export const uploadReceiveSlipFile = (file, onUploadProgress) => {
  let formData = new FormData();
  formData.append('files', file);
  return api().post('/receive-slip/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  })
}

// Huỷ đơn hàng
export const cancelOrder = (id, params = {}) => {
  return api().put(route + `/${id}/cancel`, { params });
}


// Lấy danh sách địa chỉ nhận hàng của khách hàng

export const getListAddressBook = (id, params = {}) => {
  return api().get(`/account/address-book/${id}`, { params });
}

// Thêm danh sách địa chỉ nhận hàng cho KH

export const createAddressBook = (params = {}) => {
  return api().post(`/account/address-book`, params);
}



